import logo from './logo.svg';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, Outlet } from 'react-router-dom';
import './App.css';
import "react-datepicker/dist/react-datepicker.css";
import ResetPasswordForm from 'pages/ResetPasswordForm';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import {
  fetchLoans,
  getUser,
  fetchLoanPayments,
  fetchMonthlyContributions,
  fetchLoanPaymentsToApprove,
  fetchBalanceSheet,
  fetchProfitAndLossReport,
  getActiveUserCount
} from './Features/api/api';
import { setUserIsAuthenticated } from './Features/User/userDataSlice';
import TrialBalanceSlice from './Features/Accounting/trialBalanceSlice';

// Pages
import Landing from './pages/Landing';
import SignUpForm from './pages/SignUpForm';
import ActivateAccount from './pages/ActivateAccount';
import PasswordResetForm from './components/auth/PasswordResetForm';
import LandingPage from './pages/Landing';


// Dashboard
import DashboardLayout from './components/Dashboard/DashboardLayout';
import FinancialSummary from './components/Dashboard/FinancialSummary';
import OverAllTransactions from './components/Dashboard/OverallTransactions';

// Contributions
import Contributions from './components/Contributions/Contributions';
import MonthlyContribApprovals from './components/Contributions/MonthlyContribPayApprovals';
import MonthlyContributions from './components/Contributions/ContributionsPayments';

// Loans
import LoanList from './components/Loans/LoanList';
import LoanForm from './components/Loans/LoanForm';
import LoanApplications from './components/Loans/LoanApplications';
import LoanSummary from './components/Loans/LoanSummary';
import LoanPaymentForm from './components/Loans/LoanPaymentForm';
import LoanPaymentsApprovals from './components/Loans/LoanPaymentApprovals';
import LoanApplicationApprovals from './components/Loans/LoanApplicationApprovals';
import LoanPaymentTransactions from './components/Loans/LoanPaymentTransactions';

// Accounting
import TrialBalance from './components/accounting/TrialBalance';
import BalanceSheet from './components/accounting/BalanceSheet';
import Reports from './components/accounting/Reports';
import ProfitAndLoss from './components/accounting/Profit&Loss';
import LedgerEntryForm from './components/accounting/LedgerEntryForm';

// Admin
import Admin from './components/Admin/admin';
import Directors from './components/Admin/Directors';
import Commoners from './components/Admin/commoners';

// Common/Shared
import Home from './components/Common/Home';
import News from './components/News/News';
import AllApprovals from './components/Common/AllApprovals';
import Spinner from './SharedFns/SpinnerElement';

function App() {
  const dispatch = useDispatch()
  const userLoading = useSelector(state => state.userData.loading)
  const session_cookie = localStorage.getItem("session_cookie");
  const currentDate = new Date()
  const user_group = useSelector(state => state.userData?.user?.user?.user_groups) ?? []
  const isAuthorizedAdmin = user_group.includes('Chairperson');
  const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
  useEffect(() => {


    // Check if the session cookie exists in local storage
    if (session_cookie) {
      // Perform asynchronous verification
      async function verifyUser() {
        try {
          // Verify the user's authentication state
          await dispatch(getUser());
          await dispatch(getActiveUserCount())
          await dispatch(setUserIsAuthenticated(true)); // Set user as authenticated
          await dispatch(fetchMonthlyContributions())
          await dispatch(fetchLoanPayments())
          await dispatch(fetchLoanPaymentsToApprove())
          await dispatch(fetchProfitAndLossReport({ 'start_date': formattedDate, 'end_date': formattedDate }));
          await dispatch(fetchBalanceSheet(formattedDate))




        } catch (error) {
          // Handle errors, e.g., expired session
          console.error("Verification failed:", error);
        }
      }

      // Call the verification function
      verifyUser();
    }
  }, [dispatch, session_cookie]);

  const userIsAuthenticated = useSelector(state => state.userData.userIsAuthenticated)
  const isAuthorizedApprover = user_group.includes('Sec-Gen') || user_group.includes('Treasurer');

  const ContributionRoutes = () => {
    return (
      <Routes>
        <Route path='/' element={<Contributions />} />
      </Routes>
    )
  }

  const LoanRoutes = () => {
    return (
      <Routes>
        <Route path="/" element={<LoanList />} />
        <Route path="apply-loan" element={<LoanForm />} />
        <Route path="repay-loan/:LoanId" element={<LoanPaymentForm />} />
      </Routes>
    );
  };
  const FinacialSummaryRoutes = () => {
    return (
      <Routes>
        <Route path="/" element={<FinancialSummary />} />
        <Route path="loan-summary" element={<LoanSummary />} />
        {/* <Route path="repay-loan/:LoanId" element={<LoanPaymentForm />} /> */}
      </Routes>
    );
  };
  const AllApprovalsRoutes = () => {
    return (
      <Routes>
        <Route path="/" element={<AllApprovals />} />
        <Route path='approve-monthly-contributions' element={<MonthlyContribApprovals />} />
        <Route path='approve-loan-payments' element={<LoanPaymentsApprovals />} />
        <Route path='approve-loan-applications' element={<LoanApplicationApprovals />} />
      </Routes>
    )
  }
  const TransactionRoutes = () => {
    return (
      <Routes>
        <Route path='/' element={<OverAllTransactions />}>
          <Route path='/loan-payments' element={<LoanPaymentTransactions />} />
          <Route path='/contrib-payments' element={<MonthlyContributions />} />
          <Route path='/loan-applications' element={<LoanApplications />} />
        </Route>

      </Routes>
    )
  }
  const AdminRoutes = () => {
    return (
      <Routes>
        <Route path='/' element={<Admin />} />
        <Route path='/directors' element={<Directors />} />
        <Route path='/commoners' element={<Commoners />} />
      </Routes>
    )
  }
  const AccountingRoutes = () => {
    return (
      <Routes>
        <Route path='/' element={<Reports />}>
          <Route path='/trial-balance' element={<TrialBalance />} />
          <Route path='/balance-sheet' element={<BalanceSheet />} />
          <Route path='/profit-loss' element={<ProfitAndLoss />} />
          <Route path='/post-ledger' element={<LedgerEntryForm />} />
        </Route>

      </Routes>
    )
  }
  // const DashboardLayoutRoutes=()=>{
  //   return(
  //     <Routes>
  //       <Route   index element={<Home />} />
  //               <Route path='news' element={<News />} />
  //               <Route   path= 'loans/*' element={<LoanRoutes/>}/>
  //       <Outlet/>
  //     </Routes>
  //   )
  // }

  return (
    <div>
      <Router>
        <Spinner />
        <ToastContainer 
        position="top-right" 
        autoClose={3000}
         style={{ zIndex: 99999 }}   />
        <Routes>
          <Route exact path='/' element={<LandingPage />} />
          <Route path='/sign-up' element={<SignUpForm />} />
          <Route path='/user/activate/:activation_token/' element={<ActivateAccount />} />
          <Route path='/user/forgot-password/:password_reset_token/' element={<ResetPasswordForm />} />

          {/* Authenticated Routes */}



          {userIsAuthenticated ? (
            <Route path='/dashboard/*' element={<DashboardLayout />}>

              <Route index element={<Home />} />
              <Route path='news' element={<News />} />
              <Route path='loans/*' element={<LoanRoutes />} />
              <Route path='transactions/*' element={<TransactionRoutes />} />
              {isAuthorizedApprover && <Route path='approvals/*' element={<AllApprovalsRoutes />} />}
              {isAuthorizedApprover && <Route path='financial-summary/*' element={<FinacialSummaryRoutes />} />}
              <Route path='contributions/*' element={<ContributionRoutes />} />
              <Route path='accounting/*' element={<AccountingRoutes />} />
              {isAuthorizedAdmin && <Route path='admin/*' element={<AdminRoutes />} />}
              {/* <Route index element={<LoanList />} />
               
                <Route path='apply-loan' element={<LoanForm/>}/>
                <Route path='repay-loan' element={<LoanPaymentForm/>}/> */}

            </Route>


          ) : (!userLoading && <Route
            path='/dashboard/*'
            element={<Navigate to="/" />} />
          )}








        </Routes>










      </Router>
    </div>
  );
}

export default App;
